import React from 'react';
import { Suspense, useEffect, useRef, useState } from 'react';
import { MapBox, AppProps } from '@eyeon/threejs-map';
import '@eyeon/threejs-map/index.css'

function App() {
  const appRef = useRef<HTMLDivElement>(null)
  const [args, setArgs] = useState<AppProps | null>(null);

  const configRef = useRef<AppProps>({
    config: {
      ROLE: "WP_SITE",
      CENTER_ID: 8
    },
    webApiURI: 'https://web-backend-prod.eyeonportal.com/',
  });

  useEffect(() => {
    if (appRef.current) {
      const parent = appRef.current.parentElement as HTMLDivElement;
      if (parent) {
        // Get the complete AppProps object from eyeonMapProps
        // This single object includes config, webApiURI, and onNewMapApiResponse callback
        const appProps = (parent as any).eyeonMapProps;

        if (appProps) {
          // Merge with default config and set args
          const newArgs = { ...configRef.current, ...appProps };
          setArgs({ ...newArgs });
        } else {
          // Fallback: if props not ready yet, wait for the event
          const handlePropsReady = (e: CustomEvent) => {
            const props = e.detail.props;
            if (props) {
              const newArgs = { ...configRef.current, ...props };
              setArgs({ ...newArgs });
            }
            parent.removeEventListener('eyeon:map:props:ready', handlePropsReady as EventListener);
          };
          parent.addEventListener('eyeon:map:props:ready', handlePropsReady as EventListener);
        }
      }
    }
  }, [])

  return (
    <div className="App" ref={appRef}>
      <Suspense fallback={<div className="messageStyle">Map loading, please wait...</div>}>
        {args && <MapBox {...args} />}
      </Suspense>
    </div>
  );
}

export default App;

